<template>
  <nav class="header-menu"
       aria-label="主导航">
    <a href="/"
       class="logo-link"
       @click.prevent="clickLogo">
      <img :src="props.isAi ? whiteDefaultLogo : defaultLogo"
           class="default-logo"
           alt="Flashbase 首页" />
    </a>
    <div class="flex">
      <ul class="flex">
        <template v-for="menu in menusList"
                  :key="menu.value">
          <li>
            <a-dropdown placement="bottom"
                        :trigger="'hover'">
              <button class="menuLabel"
                      :class="menuClass == menu.value ? 'menuColor' : ''"
                      @click="onClick(menu)"
                      :aria-label="menu.label">
                {{ $t(menu.label) }}
              </button>
              <template #overlay>
                <a-menu v-if="menu.value == 'product'">
                  <a-menu-item-group v-for="sub in categoryList"
                                     :key="sub.id">
                    <a-menu-item :key="sub.id"
                                 @click="subClick(menu.value, sub)">
                      {{ sub.name }}
                    </a-menu-item>
                  </a-menu-item-group>
                </a-menu>
                <a-menu v-else-if="menu.value == 'strategy' && sectorsList.length != 0">
                  <a-menu-item-group v-for="sub in sectorsList"
                                     :key="sub.id">
                    <a-menu-item :key="sub.id"
                                 class="strategyGroupItem"
                                 @click="subClick(menu.value, sub)">{{ sub.name }}
                    </a-menu-item>
                  </a-menu-item-group>
                </a-menu>
              </template>
            </a-dropdown>
          </li>
        </template>
      </ul>
      <div class="flex-btn">
        <button class="flex-btn-change"
                @click="changeLanguage"
                aria-label="切换语言">
          <span>{{ locale === 'zh_CN' ? '中文' : 'En' }}</span>
          <caret-down-outlined style="font-size: 10px;margin-left: 5px;" />
        </button>
        <a-button v-if="!isLogin"
                  class="login-btn"
                  @click="login">{{ $t('home.HeaderMenu.login') }}</a-button>
        <FlashbaseUserProfileControl v-else
                                     menu-class="flash-home-menu">
          <template #default>
            <a-menu-item @click="designClick">
              <template #icon>
                <highlight-outlined />
              </template>
              {{ $t('home.HeaderMenu.design') }}
            </a-menu-item>
          </template>
        </FlashbaseUserProfileControl>
      </div>
    </div>
    <div v-if="props.isAi"
         class="divider-box"
         aria-hidden="true"></div>
  </nav>
</template>
<script setup lang="ts">
import type { UserService } from "@/core"
import { CORE_USER } from "@/core/CoreSymbol"
import type { LoginPageOption, LoginPageService, Plugin } from "@/plugins"
import { PLUGIN_AUTH } from "@/plugins/builtin/BuiltinPluginSymbol"
import Cookie from "js-cookie"
import { container } from "tsyringe"
import { computed, ref, watch } from "vue"
import { useRouter, useRoute } from "vue-router"
import defaultLogo from "../../assets/imgs/logo.png"
import whiteDefaultLogo from "../../assets/imgs/big_LOGO.png"
import { useHomeStore } from "../../index"
import { useI18n } from "vue-i18n"
import { useSeoWithBasicSchema } from "&/utils/seo"

const { t, locale } = useI18n()
const props = defineProps<{
  menuColor: string,
  isHome?: boolean,
  isAi?: boolean
}>()
const homeStore = useHomeStore()
const route = useRoute()
const categoryList = homeStore.$state.categoryList
const sectorsList = homeStore.$state.sectors
const isLogin = computed(() => {
  const userService = container.resolve<UserService>(CORE_USER)
  const loginOptions =
    container.resolve<Plugin<LoginPageOption, LoginPageService>>(PLUGIN_AUTH)
  const isUserValid = userService.isUserValid()
  const cookie = Cookie.get(loginOptions.options.cookieKey || "iota")
  const isLogged = isUserValid && cookie && cookie.length > 0
  return isLogged
})
const login = () => {
  router.push("/signin")
}
const designClick = () => {
  router.push("/console/products/spus")
}
type menusType = Array<{
  label: string
  value: string
  to: string
  submenu?: Array<{
    label: string
    value: string
    to: string
  }>
}>
const router = useRouter()
const menusList: menusType = [
  {
    label: 'home.HeaderMenu.home',
    value: "home",
    to: "/"
  },
  // {
  //   label: 'home.HeaderMenu.dss',
  //   value: "dss",
  //   to: "/desgin_share"
  // },
  // {
  //   label: 'home.HeaderMenu.designPage',
  //   value: "design",
  //   to: "/products/custom_spus_design"
  // },
  {
    label: 'home.HeaderMenu.AI',
    value: "AI",
    to: "/AI"
  },
  // {
  //   label: 'home.HeaderMenu.mirror',
  //   value: "mirror",
  //   to: "/mirror"
  // },
  // {
  //   label: "业务介绍",
  //   value: "introduce",
  //   to: "/"
  // },
  {
    label: 'home.HeaderMenu.strategy',
    value: "strategy",
    to: "/posts"
  },
  // {
  //   label: "客户案例",
  //   value: "case",
  //   to: ""
  // },
  {
    label: 'home.HeaderMenu.aboutus',
    value: "aboutus",
    to: "/aboutus"
  }
]
const submenu = ref<string>("")
const menuClass = ref<string>("")
const onClick = (menusItem: { label: string; value: string; to: string }) => {
  router.push(menusItem.to)
}
const changeLanguage = () => {
  locale.value = locale.value === 'zh_CN' ? 'en_US' : 'zh_CN'
}
const subClick = (menu: string, sub: any) => {
  switch (menu) {
    case "product":
      router.push({ path: "/product", query: { id: sub.id, name: sub.name } })
      break
    case "strategy":
      router.push({ path: `/posts/${sub.id}`, query: { sectorName: sub.name } })
      homeStore.cmsContentItem.sector_id = sub.id
      break
  }
}
const clickLogo = () => {
  route.path !== "/" ? router.push("/") : ""
}
watch(
  () => submenu.value,
  () => {
    menuClass.value = props.menuColor ? props.menuColor : submenu.value
  },
  { immediate: true }
)

// SEO 配置 + 结构化数据
useSeoWithBasicSchema({
  title: 'Flashbase - 美派时柔性定制 - 定制您的专属产品',
  description: 'Flashbase(美派时)提供高品质定制服务，为您提供个性化定制产品，包括T恤、卫衣、帽子等多种品类，专业工厂生产，品质保障',
  keywords: 'Flashbase,美派时,柔性定制,美派时柔性定制,定制,文创,印刷,T恤,卫衣,帽子,T恤定制,卫衣定制,帽子定制,个性化定制,赛佳集团,sagaholdings',
  ogType: 'website',
})

</script>
<style scoped lang="less">
.header-menu {
  height: 100px;
  background: #f6f6f6;
  width: 100%;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  line-height: 100px;
  display: flex;
  justify-content: space-between;
  z-index: 2000;

  .divider-box {
    height: 1px;
    background-color: #f6f6f6;
    opacity: .1;
    width: 100%;
    position: absolute;
    top: 100px;
    left: 0;
  }

  .default-logo {
    width: 120px;
    height: 60px;
    margin: 20px 0 0 121px;
    cursor: pointer;
  }

  .flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .flex-btn {
    margin: 0 120px 0 41px;
    display: flex;

    .flex-btn-change {
      height: 40px;
      width: 60px;
      background-color: #ededed;
      color: #999999;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    :deep(.user-profile-control) {
      color: #111111;
    }
  }

  .login-btn {
    height: 40px;
    width: 98px;
    justify-content: flex-end;
    color: #fff;
    background-color: #111;
  }

  .menuLabel {
    min-width: 50px;
    height: 100px;
    overflow-wrap: break-word;
    color: #111;
    font-size: 20px;
    font-family: "Microsoft YaHei Light";
    font-weight: 300;
    text-align: left;
    white-space: nowrap;
    line-height: 100px;
    margin: 0 20px;
    cursor: pointer;

    &:hover {
      font-family: "Microsoft YaHei Bold";
      font-weight: bold;
    }

    &.active {
      font-family: "Microsoft YaHei Bold";
      font-weight: bold;
    }
  }

  .menuColor {
    font-family: "Microsoft YaHei Bold";
    font-weight: bold;
  }

  .strategy {
    color: #fff;
    background-color: #002fa7;
  }

  :deep(.username) {
    min-width: 60px;
    width: 100%;
    max-width: 20vw;
  }
}


:deep(.ant-dropdown-menu-item) {
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100px;
  font-size: 16px;
  font-family: "Microsoft YaHei";
  color: #111;
  // text-align: center;
  padding-right: 0;
}
</style>
